import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getUser } from "@/integrations/aws/auth";
import { Loader2 } from "lucide-react";
import { AppShell } from "@/components/app-shell";
import { useAuth } from "@/lib/auth";
import { usePresenceHeartbeat } from "@/hooks/use-presence-heartbeat";

/**
 * Every signed-in page, with the presence heartbeat running underneath.
 *
 * It sits here rather than on the attendance page because the point is to
 * notice somebody working, wherever in the app they happen to be. The server
 * ignores it for anybody who is not on the payroll.
 */
function AuthenticatedLayout() {
  usePresenceHeartbeat(true);
  const { loading } = useAuth();

  /*
   * Nothing is drawn until the roles are in. Every page and the nav read them,
   * and a page drawn before they arrive shows a super admin the "no role" notice
   * and an empty Administration menu.
   */
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-label="Loading" />
      </div>
    );
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    const user = await getUser();
    // The page asked for rides along, so signing in lands back on it.
    if (!user) throw redirect({ to: "/auth", search: { redirect: location.href } });
    return { user };
  },
  component: AuthenticatedLayout,
});
